module.exports = __webpack_public_path__ + "img/DK45801012.372b16c4.png";